<template>
  <div
    class="video-main"
    :class="{ 'video-main--flipped': !sharedScreen }"
  />
</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      default: () => {},
    },
    sharedScreen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    video: {
      handler() {
        this.$nextTick().then(() => {
          const attach = this.video?.attach ?? null;
          if (!attach) {
            this.$el.innerHTML = '';
            return;
          }
          if (this.$el) {
            this.$el.innerHTML = '';
            console.log('this.video', this.video);
            this.$el.appendChild(this.video.attach());
          }
        });
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$breakpoint-1: 600px;
.video-main {
  width: 100%;
  @media (min-width: $breakpoint-1) {
    overflow: hidden;
  }

  &::v-deep video {
    width: 100% !important;
    height: calc(100vh - 160px);
    min-height: 400px;
    // height: 100%;
    object-fit: contain;
    border-radius: 5px;
    @media (min-width: $breakpoint-1) {
      height: auto !important;
      max-height: calc(100vh - 240px);
      object-fit: contain;
      object-position: 50% 0;
      border-radius: 0;
    }

    @media (min-width: 1228px) {
      max-height: calc(100vh - 180px);
    }
  }
  &--flipped::v-deep video {
    transform: scaleX(-1);
  }
}
</style>
